var FcLocationInputModule = /** @class */ (function () {
    function FcLocationInputModule() {
    }
    return FcLocationInputModule;
}());
export { FcLocationInputModule };
